import { action, createRequestTypes } from '@/utils/actions.utils'
import { projectService } from '@/services'
import { uiActions, projectsActions } from '@/redux/actions'
import Toggles from '@domain/toggles/Toggles'
import { ERROR_403_PATH } from '@/constants'

export const GET_PROJECT = createRequestTypes('GET_PROJECT')
const getProject = ({
	projectId,
	lang,
	withPrices = false,
	parseProducts = false,
	hotUpdate = false,
}) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ projectId, hotUpdate }))
			const res = await projectService.getProjectv2({ projectId, lang, withPrices, isProjectPage: parseProducts })
			return dispatch(success(res.data))
		} catch (error) {
			if (error?.response?.status === 403) {
				dispatch(uiActions.navigateTo({ path: ERROR_403_PATH }))
			}

			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(GET_PROJECT.REQUEST, payload)
	}
	function success(payload) {
		return action(GET_PROJECT.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_PROJECT.FAILURE, null, err)
	}
}

export const CREATE_PROJECT = createRequestTypes('CREATE_PROJECT')
const createProject = ({ catalogId, products = [], config, name, redirectTo, v = 1 }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())
			let res;
			if (v == 1) {
				res = await projectService.createProject({
					catalogId,
					products,
					name
				})
				if (Toggles.isEnabled('upsertVersionD365')) {
					await projectService.upsertVersionV2(res.data.id)
				}
			} else {
				res = await projectService.createProjectv2({
					catalogId,
					products,
					name,
					config
				})
			}

			const successResponse = await dispatch(success({ id: res.data.id, name }))

			if (redirectTo) {
				const path = redirectTo.replace(':projectId', res.data.id)
				dispatch(uiActions.navigateTo({ path }))
			}

			return successResponse
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(CREATE_PROJECT.REQUEST)
	}
	function success(payload) {
		return action(CREATE_PROJECT.SUCCESS, payload)
	}
	function failure(err) {
		return action(CREATE_PROJECT.FAILURE, null, err)
	}
}

const createProjectWithReferences = ({ catalogId, collection, referencesDetails, projectName, redirectTo }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectService.createProjectWithReferences({
				catalogId,
				collection,
				referencesDetails,
				projectName
			})

			const successResponse = await dispatch(
				success({
					...res.data,
					name: projectName
				})
			)

			if (Toggles.isEnabled('upsertVersionD365')) {
				await projectService.upsertVersionV2(res.data.id)
			}

			if (redirectTo) {
				const path = redirectTo.replace(':projectId', res.data.id)
				dispatch(uiActions.navigateTo({ path }))
			}

			return successResponse
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(CREATE_PROJECT.REQUEST)
	}
	function success(payload) {
		return action(CREATE_PROJECT.SUCCESS, payload)
	}
	function failure(err) {
		return action(CREATE_PROJECT.FAILURE, null, err)
	}
}

export const UPDATE_PROJECT = createRequestTypes('UPDATE_PROJECT')
const updateProject = ({ projectId, fieldsToUpdate, hotUpdate = true, redirectTo }) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ projectId, hotUpdate }))
			
				await projectService.updateProject({ projectId, fieldsToUpdate })
			if (Toggles.isEnabled('upsertVersionD365')) {
				await projectService.upsertVersionV2(projectId)
			}
			
			if (redirectTo) {
				const path = redirectTo.replace(':projectId', projectId)
				dispatch(uiActions.navigateTo({ path }))
			}

			return dispatch(success(fieldsToUpdate))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(UPDATE_PROJECT.REQUEST, payload)
	}
	function success(payload) {
		return action(UPDATE_PROJECT.SUCCESS, payload)
	}
	function failure(err) {
		return action(UPDATE_PROJECT.FAILURE, null, err)
	}
}

export const DELETE_PROJECT = createRequestTypes('DELETE_PROJECT')
const deleteProject = ({ projectId, projectName, history }) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ projectId }))

			await projectService.deleteProject(projectId)
			history && history.push(`/`)
			return dispatch(success({ projectId, projectName }))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(DELETE_PROJECT.REQUEST, payload)
	}
	function success(payload) {
		return action(DELETE_PROJECT.SUCCESS, payload)
	}
	function failure(err) {
		return action(DELETE_PROJECT.FAILURE, null, err)
	}
}
export const DUPLICATE_PROJECT = createRequestTypes('DUPLICATE_PROJECT')
const duplicateProject = ({ projectId, redirectToProject = false, resetProjectsList = false, showError = true }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectService.duplicateProject(projectId)

			if (redirectToProject) {
				dispatch(uiActions.navigateTo({ path: `/project/${res.data.id}` }))
			}
			if (resetProjectsList) {
				dispatch(projectsActions.fetchProjectList({ itemsToLoad: 4, resetList: true }))
			}
			return dispatch(success({ id: res.data.id }))
		} catch (error) {
			return dispatch(failure(error, showError))
		}
	}

	function request(payload) {
		return action(DUPLICATE_PROJECT.REQUEST, payload)
	}
	function success(payload) {
		return action(DUPLICATE_PROJECT.SUCCESS, payload)
	}
	function failure(err, showError) {
		return action(DUPLICATE_PROJECT.FAILURE, null, err, showError)
	}
}

export const VERSION_PROJECT = createRequestTypes('VERSION_PROJECT')
const versionProject = ({ projectId, redirectToProject = false, resetProjectsList = false, showError = true, email = null }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectService.versionProject(projectId, email)

			if (redirectToProject) {
				dispatch(uiActions.navigateTo({ path: `/project/${res.data.id}` }))
			}
			if (resetProjectsList) {
				dispatch(projectsActions.fetchProjectList({ itemsToLoad: 4, resetList: true }))
			}

			return dispatch(success({ id: res.data.id }))
			
		} catch (error) {
			return dispatch(failure(error, showError))
		}
	}

	function request(payload) {
		return action(VERSION_PROJECT.REQUEST, payload)
	}
	function success(payload) {
		return action(VERSION_PROJECT.SUCCESS, payload)
	}
	function failure(err, showError) {
		return action(VERSION_PROJECT.FAILURE, null, err, showError)
	}
}

export const GET_PROJECT_VERSIONS = createRequestTypes('GET_PROJECT_VERSIONS')
const getProjectVersions = ({
	projectId,
	hotUpdate = false,
}) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ projectId, hotUpdate }))
			const res = await projectService.getProjectVersions(projectId)
			return dispatch(success(res.data))
		} catch (error) {
			if (error?.response?.status === 403) {
				dispatch(uiActions.navigateTo({ path: ERROR_403_PATH }))
			}

			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(GET_PROJECT_VERSIONS.REQUEST, payload)
	}
	function success(payload) {
		return action(GET_PROJECT_VERSIONS.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_PROJECT_VERSIONS.FAILURE, null, err)
	}
}


export const ADD_PRODUCT = createRequestTypes('ADD_PRODUCT')
const addProduct = ({ projectId, product, redirectTo }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			await projectService.addProduct({
				projectId,
				product
			})
			if (Toggles.isEnabled('upsertVersionD365')) {
				await projectService.upsertVersionV2(projectId)
			}

			if (redirectTo) {
				const path = redirectTo.replace(':projectId', projectId)
				dispatch(uiActions.navigateTo({ path }))
			}
			return dispatch(success({ projectId, product }))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(ADD_PRODUCT.REQUEST, payload)
	}
	function success(payload) {
		return action(ADD_PRODUCT.SUCCESS, payload)
	}
	function failure(err) {
		return action(ADD_PRODUCT.FAILURE, null, err)
	}
}

export const ADD_PRODUCTS = createRequestTypes('ADD_PRODUCTS')
const addProducts = ({ projectId, products, redirectTo, config, v = 1 }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			if (v === 1) {
				await projectService.addProducts({
					projectId,
					products
				})
				if (Toggles.isEnabled('upsertVersionD365')) {
					await projectService.upsertVersionV2(projectId)
				}
			} else {
				await projectService.addProductsV2({
					projectId,
					products,
					config
				})
			}
			if (redirectTo) {
				const path = redirectTo.replace(':projectId', projectId)
				dispatch(uiActions.navigateTo({ path }))
			}
			return dispatch(success({ projectId, products }))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(ADD_PRODUCTS.REQUEST, payload)
	}
	function success(payload) {
		return action(ADD_PRODUCTS.SUCCESS, payload)
	}
	function failure(err) {
		return action(ADD_PRODUCTS.FAILURE, null, err)
	}
}

export const ADD_PRODUCT_BY_REF = createRequestTypes('ADD_PRODUCT_BY_REF')
const addProductByRef = ({ projectId, reference, lang, withPrices }) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ projectId, reference }))

			await projectService.addProductByRef({ projectId, reference })
			if (Toggles.isEnabled('upsertVersionD365')) {
				await projectService.upsertVersionV2(projectId)
			}
			await dispatch(projectActions.getProject({ projectId, lang, withPrices, hotUpdate: true }))
			return dispatch(success({ projectId, reference }))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(ADD_PRODUCT_BY_REF.REQUEST, payload)
	}
	function success(payload) {
		return action(ADD_PRODUCT_BY_REF.SUCCESS, payload)
	}
	function failure(err) {
		return action(ADD_PRODUCT_BY_REF.FAILURE, null, err)
	}
}

export const ADD_PRODUCTS_BY_REF = createRequestTypes('ADD_PRODUCTS_BY_REF')
const addProductsByRef = ({ projectId, collection, referencesDetails, redirectTo }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			await projectService.addProductsByRef({
				projectId,
				collection,
				referencesDetails
			})

			if (Toggles.isEnabled('upsertVersionD365')){
				await projectService.upsertVersionV2(projectId)
			} 
			
			if (redirectTo) {
				const path = redirectTo.replace(':projectId', projectId)
				dispatch(uiActions.navigateTo({ path }))
			}
			return dispatch(success({ projectId, collection, referencesDetails }))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(ADD_PRODUCTS_BY_REF.REQUEST, payload)
	}
	function success(payload) {
		return action(ADD_PRODUCTS_BY_REF.SUCCESS, payload)
	}
	function failure(err) {
		return action(ADD_PRODUCTS_BY_REF.FAILURE, null, err)
	}
}

export const CLONE_PRODUCT = createRequestTypes('CLONE_PRODUCT')
const cloneProduct = ({ projectId, productId, lang, withPrices, product, catalog }) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ projectId, productId }))
			await projectService.cloneProduct({ projectId, productId, product, catalog })

			if (Toggles.isEnabled('upsertVersionD365')) {
				await projectService.upsertVersionV2(projectId)
			}

			await dispatch(projectActions.getProject({ projectId, lang, withPrices, hotUpdate: true }))
			return dispatch(success({ projectId, productId }))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(CLONE_PRODUCT.REQUEST, payload)
	}
	function success(payload) {
		return action(CLONE_PRODUCT.SUCCESS, payload)
	}
	function failure(err) {
		return action(CLONE_PRODUCT.FAILURE, null, err)
	}
}

export const DELETE_PRODUCT = createRequestTypes('DELETE_PRODUCT')
const deleteProduct = ({ projectId, productId }) => {
	return async (dispatch) => {
		try {
			await dispatch(request({ projectId, productId }))

			await projectService.deleteProduct({ projectId, productId })
			if(Toggles.isEnabled('upsertVersionD365')){
				await projectService.upsertVersionV2(projectId)
			}
			return dispatch(success({ projectId, productId }))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request(payload) {
		return action(DELETE_PRODUCT.REQUEST, payload)
	}
	function success(payload) {
		return action(DELETE_PRODUCT.SUCCESS, payload)
	}
	function failure(err) {
		return action(DELETE_PRODUCT.FAILURE, null, err)
	}
}

export const UPDATE_PRODUCT = createRequestTypes('UPDATE_PRODUCT')
const updateProduct = ({
	projectId,
	productId,
	attributesToUpdate,
	redirectTo,

	config,
	products,
	v = 1
}) => {
	return async (dispatch) => {
		try {
			await dispatch(request())
			if (v == 1) {
				await projectService.updateProduct({ projectId, productId, attributesToUpdate })
				if (Toggles.isEnabled('upsertVersionD365')){
					await projectService.upsertVersionV2(projectId)
				}
			} else {
				await projectService.updateProjectv2({ projectId, products, config })
			}

			if (redirectTo) {
				const path = redirectTo.replace(':projectId', projectId)
				dispatch(uiActions.navigateTo({ path }))
			}

			return dispatch(success({ projectId, productId: productId || products[0]._id }))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(UPDATE_PRODUCT.REQUEST)
	}
	function success(payload) {
		return action(UPDATE_PRODUCT.SUCCESS, payload)
	}
	function failure(err) {
		return action(UPDATE_PRODUCT.FAILURE, null, err)
	}
}

export const GET_PROJECT_TOOLTIP_INFO = createRequestTypes('GET_PROJECT_TOOLTIP_INFO')
const getTooltipInfo = ({ projectId }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectService.getTooltipInfo({ projectId })
			return dispatch(
				success({
					id: projectId,
					...res.data
				})
			)
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(GET_PROJECT_TOOLTIP_INFO.REQUEST)
	}
	function success(payload) {
		return action(GET_PROJECT_TOOLTIP_INFO.SUCCESS, payload)
	}
	function failure(err) {
		return action(GET_PROJECT_TOOLTIP_INFO.FAILURE, null, err, false)
	}
}

export const CREATE_REQUEST_BUDGET = createRequestTypes('CREATE_REQUEST_BUDGET')
const createRequestBudget = ({ lang, files, siteLocation, catalogId, description, project }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectService.createRequestBudget({
				lang,
				files,
				siteLocation,
				catalogId,
				description,
				project
			})
			dispatch(success(res.data))
			return dispatch(uiActions.setActionDone(action(CREATE_REQUEST_BUDGET.SUCCESS, res.data)))
		} catch (error) {
			dispatch(failure(error))
			return dispatch(uiActions.setActionDone(action(CREATE_REQUEST_BUDGET.FAILURE, null, error)))
		}
	}

	function request() {
		return action(CREATE_REQUEST_BUDGET.REQUEST)
	}
	function success(payload) {
		return action(CREATE_REQUEST_BUDGET.SUCCESS, payload)
	}
	function failure(err) {
		return action(CREATE_REQUEST_BUDGET.FAILURE, null, err)
	}
}

export const UPDATE_PROJECT_THIRD_PARTY = 'UPDATE_PROJECT_THIRD_PARTY'
const updateProjectThirdParty = (payload) => {
	return action(UPDATE_PROJECT_THIRD_PARTY, payload)
}
export const EMPTY_PROJECT_DETAILS = 'EMPTY_PROJECT_DETAILS'
const emptyProjectDetails = () => {
	return action(EMPTY_PROJECT_DETAILS)
}

export const FETCH_PROJECT_TECH_INFO = createRequestTypes('FETCH_PROJECT_TECH_INFO')
const fetchProjectTechInfo = (projectId) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectService.getProjectTechInfo(projectId)
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_PROJECT_TECH_INFO.REQUEST)
	}
	function success(payload) {
		return action(FETCH_PROJECT_TECH_INFO.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_PROJECT_TECH_INFO.FAILURE, null, err)
	}
}

export const FETCH_PROJECT_CONTEXT = createRequestTypes('FETCH_PROJECT_CONTEXT')
const fetchProjectContext = ({ projectId, lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectService.getProject({ projectId, lang })
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_PROJECT_CONTEXT.REQUEST)
	}
	function success(payload) {
		return action(FETCH_PROJECT_CONTEXT.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_PROJECT_CONTEXT.FAILURE, null, err)
	}
}

export const FETCH_PROJECT_PERSONALIZED_PRODUCT = createRequestTypes('FETCH_PROJECT_PERSONALIZED_PRODUCT')
const getProjectPersonalizedProducts = ({ projectId, lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await projectService.getProjectPersonalizedProducts({ projectId, lang })
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_PROJECT_PERSONALIZED_PRODUCT.REQUEST)
	}
	function success(payload) {
		return action(FETCH_PROJECT_PERSONALIZED_PRODUCT.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_PROJECT_PERSONALIZED_PRODUCT.FAILURE, null, err)
	}
}

export const MODAL_PROJECT_CLOSE = 'MODAL_PROJECT_CLOSE'
const modalProjectClose = (payload) => {
	return action(MODAL_PROJECT_CLOSE, payload)
}

export const NEW_THIRD_PARTY_PROJECT = 'NEW_THIRD_PARTY_PROJECT'
const newThirdPartyProject = (payload) => {
	return action(NEW_THIRD_PARTY_PROJECT, payload)
}

export const ADD_MODEL_STANDARD = 'ADD_MODEL_STANDARD'
const addModelStandard = (payload) => {
	return action(ADD_MODEL_STANDARD, payload)
}

export const CLOSE_MODAL_ADD_PRODUCT = 'CLOSE_MODAL_ADD_PRODUCT'
const closeModalAddProduct = (payload) => {
	return action(CLOSE_MODAL_ADD_PRODUCT, payload)
}
export const UPDATE_PROJECT_NAME = createRequestTypes('UPDATE_PROJECT_NAME')
const updateProjectName = ({projectId, newName}) => {
	return async (dispatch) => {
		try {
			await dispatch(request())
			const res = await projectService.updateProjectName(projectId, newName)
			return dispatch(success(res.data))

		} catch (error) {
			dispatch(failure(error))
		}
	}

	function request(payload) {
		return action('request', payload)
	}
	function success(payload) {
		return action('success', payload)
	}
	function failure(err) {
		return action('failure', null, err)
	}
}

const getProjectName = ({projectId}) => {
	return async (dispatch) => {
		try {
			await dispatch(request())
			const res = await projectService.getProjectName(projectId)
			return dispatch(success(res.data))

		} catch (error) {
			dispatch(failure(error))
		}
	}
	
	function request(payload) {
		return action('request', payload)
	}
	function success(payload) {
		return action('success', payload)
	}
	function failure(err) {
		return action('failure', null, err)
	}

}



const projectActions = {
	getProject,
	createProject,
	createProjectWithReferences,
	deleteProject,
	duplicateProject,
	versionProject,
	getProjectVersions,
	emptyProjectDetails,
	updateProject,
	addProduct,
	addProducts,
	addProductByRef,
	addProductsByRef,
	cloneProduct,
	deleteProduct,
	updateProduct,
	getTooltipInfo,
	createRequestBudget,
	updateProjectThirdParty,
	fetchProjectTechInfo,
	fetchProjectContext,
	getProjectPersonalizedProducts,
	modalProjectClose,
	addModelStandard,
	closeModalAddProduct,
	newThirdPartyProject,
	updateProjectName,
	getProjectName,
}

export default projectActions
